/** @jsx jsx */

import { Colors } from '@zapier/design-system';
import { Spacing } from '@zapier/theme';
import { css } from '@emotion/core';

const Styles = {
  request: (borderColor: string) => [
    css`
      margin: 0px 0px 15px;
      border: 1px solid ${borderColor};
      border-radius: 10px;
    `,
  ],
  editor: (borderColor: string) => [
    css`
      border: 1px solid ${borderColor};
      border-radius: 10px;
    `,
  ],
  footer: css`
    display: flex;
    flex-direction: column;
    border-top: 1px solid ${Colors.GrayWarm4};
    padding: 15px;
    gap: ${Spacing.medium}px;
  `,
  wrapper: css`
    display: flex;
    align-items: center;
    gap: ${Spacing.small}px;
  `,
};

export default Styles;
